// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleInternalDeereCommentsChange(event) {

    this.onInternalDeereCommentsChange(event.target.value);

}

function handleCommentsToDealerChange(event) {

    this.onCommentsToDealerChange(event.target.value);

}

const Comments = props =>
    <section className='comments'>
        <header>
            <FormattedMessage id='COMMENTS'/>
        </header>
        <section className='comments-section'>
            <FormattedMessage id='INTERNAL_DEERE_COMMENTS'/>
            <textarea
                className='internal-deere-comments'
                onChange={props::handleInternalDeereCommentsChange}
                rows={5}
                value={props.internalDeereComments}
            />
            <FormattedMessage id='COMMENTS_TO_DEALER'/>
            <textarea
                onChange={props::handleCommentsToDealerChange}
                rows={5}
                value={props.commentsToDealer}
            />
        </section>
    </section>;

Comments.displayName = 'Comments';
Comments.propTypes = {
    commentsToDealer: PropTypes.string.isRequired,
    internalDeereComments: PropTypes.string.isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default Comments;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/comments.js